import React from 'react';
import { TrendingUp, Clock, Users, CheckCircle, Target } from 'lucide-react';

const EngineOutcomes = () => {
  const outcomes = [
    { icon: TrendingUp, text: '2.5× faster skill mastery compared to traditional Training' },
    { icon: Target, text: '35% higher retention when Training is paired with role-play' },
    { icon: Clock, text: 'Faster onboarding and ramp time' },
    { icon: Users, text: 'Reduced manager coaching hours' },
    { icon: CheckCircle, text: 'Higher Training completion and consistency' }
  ];

  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
            Measured <span className="text-cyan-400">Outcomes</span>
          </h2>
          <p className="text-xl text-gray-300">
            Organizations using Traain Engine experience:
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4 mb-12">
          {outcomes.map((outcome, index) => {
            const Icon = outcome.icon;
            return (
              <div
                key={index}
                className="flex items-center gap-4 p-5 rounded-xl bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50 hover:border-cyan-500/50 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-cyan-500/20 to-blue-500/20 flex items-center justify-center flex-shrink-0">
                  <Icon className="w-6 h-6 text-cyan-400" />
                </div>
                <p className="text-lg text-gray-300">{outcome.text}</p>
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <p className="text-gray-400 italic">
            These results reflect real enterprise usage — not projections.
          </p>
        </div>
      </div>
    </section>
  );
};

export default EngineOutcomes;
